<script>
import { Line } from 'vue-chartjs';

export default {
  name: "AccumulatedConsumeChart",
  extends: Line,
  props: {
    chartLabels: {
      type: Array,
      required: true
    },
    chartDataValues: {
      type: Array,
      required: true
    },
    formatDateRange: {
      type: String,
      required: true
    },
    componentKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chartData: {
        labels: this.chartLabels,
        datasets: [
          {
            label: `Consumo Acumulado (kg) - ${this.formatDateRange}`,
            data: this.chartDataValues,
            backgroundColor: 'rgba(91, 138, 52, 0.9)',
            borderColor: 'rgba(91, 138, 52, 0.9)',
            borderWidth: 2,
            fill: true,
            tension: 0.1,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'kg acumulados'
            },
            ticks: {
              callback: function(value) {
                return value + ' kg';
              }
            }
          },
          x: {
            title: {
              display: true,
              text: 'Fecha'
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context) {
                return 'Consumo acumulado: ' + context.parsed.y + ' kg';
              }
            }
          },
          legend: {
            display: false
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script> 